import { render, staticRenderFns } from "./MyInput.vue?vue&type=template&id=6352742b&scoped=true&"
import script from "./MyInput.vue?vue&type=script&lang=js&"
export * from "./MyInput.vue?vue&type=script&lang=js&"
import style0 from "./MyInput.vue?vue&type=style&index=0&id=6352742b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6352742b",
  null
  
)

export default component.exports